module.exports = __webpack_public_path__ + "static/wolfs-gravestone-6d435b815304cb0cd3b079a0f22554ca.png";